import type { QueryClient } from '@tanstack/react-query';

/** List query roots that have a matching metadata options cache. */
const LIST_TO_OPTIONS_KEY: Record<string, string> = {
  contacts: 'contacts',
  leads: 'leads',
  offerings: 'offerings',
  'offering-categories': 'offering-categories',
  campaigns: 'campaigns',
  users: 'users',
  'customer-segments': 'customer-segments',
};

/**
 * Invalidates paginated list queries and related metadata option dropdowns together
 * so tables and selects stay in sync after mutations.
 */
export function invalidateListResource(queryClient: QueryClient, listQueryRoot: string): void {
  void queryClient.invalidateQueries({ queryKey: [listQueryRoot] });

  const optionsKey = LIST_TO_OPTIONS_KEY[listQueryRoot];
  if (optionsKey) {
    void queryClient.invalidateQueries({ queryKey: ['options', optionsKey] });
  }
}

/** Kanban uses a separate query root from the paginated leads list. */
export function invalidateLeadsViews(queryClient: QueryClient): void {
  invalidateListResource(queryClient, 'leads');
  void queryClient.invalidateQueries({ queryKey: ['leads-kanban'] });
}
